import React from "react";

const BlanketLicenses = () => {
  return (
    <div>
      <p className="detail-text paragraph">
        <p className="paragraph-title">
          What’s included in my blanket license?
        </p>
        Subscribers have immediate access to all files, from the browse screen
        they can directly download the multitrack stem files and variation files
        in full quality (24bit WAV). They have full access to the collaboration
        tools of the website allowing them to create a team and share projects
        to other users.
      </p>
      <p className="detail-text paragraph">
        <p className="paragraph-title">
          Do I need to keep my subscription after I’ve finished publishing the
          work?
        </p>
        No, your blanket license covers work published in the subscription
        window in-perpetuity. So your online work can stay up forever without
        requiring you to maintain a subscription license. Since the subscription
        also provides access to all the files, most creators start a blanket
        license during production.
      </p>
      <p className="detail-text paragraph">
        <p className="paragraph-title">
          What is the difference between the 3 license levels?
        </p>
        Our blanket licenses are offered on a sliding scale based on overall
        project budget (calculated monthly). “Project budget” in this case
        refers to the overall project that the media is a part of and should be
        inclusive of all costs associated with the project. It can be hard to
        have this as an exact figure (particularly during production), so our
        license levels have a wide range and allow for major discounts for small
        time creators that may only see a small amount of revenue from ads or
        other monetization. A lot of work is produced by salaried professionals
        and accordingly you can simply add 1/12th of that figure to the monthly
        project budget.
      </p>
      <p className="detail-text paragraph">
        <p className="paragraph-title">
          Can a blanket license cover multiple projects?
        </p>
        Our stock blanket licenses are intended to cover a single project (one
        podcast, one YouTube channel, etc.). Many professional creators might
        need a more flexible licensing structure if they produce a variety of
        work for different clients or if they have multiple shows under a single
        company. We offer custom “Network Blanket Licenses” that can cover any
        number of shows for a discounted rate. These are all special
        arrangements so feel free to reach out to us with any questions you
        might have about it.
      </p>
    </div>
  );
};

export default BlanketLicenses;
